import React from 'react'
import Labels from '../../../../common/Labels';
import { Grid, Label } from 'semantic-ui-react';
class Description extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        const { selectedContent } = this.props

        return (
            <div >
                <Labels
                    text={selectedContent.description}
                    htmlView={true} />
            </div >
        )
    }
}

export default Description